import * as $ from 'jquery';
import './promotions-grid-theme.scss';

import { replaceTags, RegexPatterns, resolveUrls } from '../helpers/template-utils';
import * as Utils from '../helpers/utils';

export interface Config {
  wrapperEl: Element;
  onComponentMount?: Function;
  data: {
    currencies: {
      [index: string]: any;
    },
    globalProperties?: {
      [index: string]: any;
    },
    resolverUrl?: string,
    items?: Array<string>
  };
}

export class PromotionsGrid {

  compId: string;
  promotionsGrid: any;

  constructor(private config: Config) {
    this.compId = Utils.uniqueId();
    this.initialize();
  }

  public initialize() {
    const { items, resolverUrl, globalProperties, currencies } = this.config.data;
    if (items && items.length > 0) {
      const packages: Array<string> = items
        .map(item => resolveUrls(resolverUrl, item))
        .map(item => replaceTags(RegexPatterns.currencies, currencies, item))
        .map(item => replaceTags(RegexPatterns.templateTags, globalProperties, item));

      this.render(packages);
      Utils.addScrmClickEventsToChildren(this.promotionsGrid);
    }
  }

  public render(packages: Array<string>) {

    // .. create the parent node & grid <ul> list
    const promotionsGrid = $('<ul></ul>', { class: 'scrm_promogrid--list' });

    // .. find all script nodes and append to the grid list element
    const scriptNodes = Utils.getScriptNodesFromPackages(packages);
    packages.forEach(item => promotionsGrid.append(`<li class="scrm_promogrid__itemWrapper">${item}</li>`));

    // .. remove any script nodes
    Utils.removeScriptNodes(promotionsGrid);

    // .. add the script nodes to the parent node
    promotionsGrid.append(scriptNodes);

    // .. cleanup any existing DOM nodes
    $(this.config.wrapperEl).empty();

    // .. add the parent node to the page
    promotionsGrid.appendTo(this.config.wrapperEl);

    // .. keep a reference to the promotions grid
    this.promotionsGrid = promotionsGrid;

    if (this.config.onComponentMount) {
      this.config.onComponentMount();
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/promotions-grid.ts